import React from "react";

import StatusIndicator from "components/school_money/history/StatusIndicator";

export default class ClubBookingStatusIndicator extends React.Component {
  
  getStatusIndicatorProps() {
    const { status, sessionNumber } = this.props;
    switch (status) {
      case "ATTENDED":
        if (sessionNumber === null) {
          return { color: "#87BC49", label: "Attended" };
        } else {
          return { color: "#87BC49", label: "Attended", iconContent: sessionNumber };
        }
      case "NOT_ATTENDED":
        return { color: "#B5CFDB", label: "Not Attended" };
      case "HOLIDAY":
        return { color: "#808080", label: "School Holiday" };
      default:
        return {};
    }
  }
  
  render() {
    return <StatusIndicator {...this.getStatusIndicatorProps()} />;
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/history/ClubBookingStatusIndicator.js